


















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {TimeZone} from "@/models/TimeZone";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";

@Component({
  components: {CommonButton, CommonInput}
})
export default class TimeZoneCard extends Vue {
  private searchValue:string = '';
  private zoneList: Array<TimeZone> = [];
  private selected:number|undefined = 0;
  private selectedZone:TimeZone|null = null;

  @Prop({default: []})
  private list!: Array<TimeZone>;

  @Prop()
  private zoneId?: number;

  @Watch('zoneId')
  watchPropsValue() {
    this.changeZoneId();
  }

  @Watch('searchValue')
  watchSearchValue(newValue: string) {
    let newList: Array<any> = [];
    if (this.searchValue) {
      this.selected = undefined;
      this.list.forEach((item:any) => {
        if (item.name.toLowerCase().indexOf(this.searchValue) >= 0) {
          newList.push(item);
          if (this.selectedZone && item.name === this.selectedZone.name) {
            this.selected = newList.length-1;
          }
        }
      })
      this.zoneList = newList;
    } else {
      this.zoneList = this.list;
      this.zoneList.forEach((item:any, index: number) => {
        if (this.selectedZone && item.name === this.selectedZone.name) {
          this.selected = index;
        }
      })
    }
  }

  private async created() {
    this.zoneList = this.list;
    this.changeZoneId();
  }

  private handleOnChange(e: any) {
    this.selectedZone = e ? this.list[e] : null;
  }

  private handleCancel() {
    this.$emit('timeZone',  false)
  }

  private handleSelect() {
    this.$emit('timeZone',  this.selectedZone ? this.selectedZone : false)
  }

  private changeZoneId() {
    if (this.zoneId) {
      this.list.forEach((item:any, index:number) => {
        if (item.id === this.zoneId) {
          this.selectedZone = item;
          this.selected = index;
        }
      })
    }
  }
}
